import { bootstrapApplication } from '@angular/platform-browser';
import { setScriptKey } from '@progress/kendo-licensing';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { KENDO_LICENSE_KEY } from './kendo-license';

setScriptKey(KENDO_LICENSE_KEY);

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  throw err;
});
